<div class="d-flex flex-column h-100 gap-3">
  <div class="flex-fill overflow-hidden">
    <div class="table-outer table-theme">
      <div class="table-responsive h-100">
        <p-table
          [value]="items()"
          styleClass="p-datatable-sm"
          [tableStyle]="{ 'min-width': '56rem' }"
          dataKey="id"
          [expandedRowKeys]="expandedRows"
          (onRowExpand)="onRowExpand($event)"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 4rem"></th>
              <th pSortableColumn="modelElevation">Model/Elevation<p-sortIcon field="modelElevation"></p-sortIcon></th>
              <th pSortableColumn="assigned">Assigned <p-sortIcon field="assigned"></p-sortIcon></th>
              <th>Sales Office</th>
              <th>Design Center</th>
              <th pSortableColumn="sellable">Sellable <p-sortIcon field="sellable"></p-sortIcon></th>
              <th pSortableColumn="global">Global <p-sortIcon field="global"></p-sortIcon></th>
              <th>Sel Req</th>
              <th>UofM</th>
              <th class="text-end" pSortableColumn="quantity">Quantity <p-sortIcon field="quantity"></p-sortIcon></th>
              <th class="text-end" pSortableColumn="unitPrice">
                Unit Price <p-sortIcon field="unitPrice"></p-sortIcon>
              </th>
              <th class="text-end">Amount</th>
              <th class="text-center">Actions</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-row let-expanded="expanded">
            <tr>
              <td>
                @if (hasLinkedProducts(row)) {
                  <i
                    class="bi text-body-secondary fs-16 cursor-pointer"
                    [ngClass]="expanded ? 'bi-chevron-up' : 'bi-chevron-down'"
                    [pRowToggler]="row"
                  ></i>
                }
              </td>
              <td>
                @if (row.applyToAllModelsAndElevations || row.isAllModels || row.isAllElevations) {
                  {{ row.applyToAllModelsAndElevations || row.isAllModels ? 'All Models' : row.modelId || '—' }} /
                  {{
                    row.applyToAllModelsAndElevations || row.isAllElevations ? 'All Elevations' : row.elevationId || '—'
                  }}
                } @else if (row.assignments?.length) {
                  <div class="d-flex flex-column gap-1">
                    @for (assignment of row.assignments; track assignment.id) {
                      <span>
                        {{ assignment.model?.modelName || assignment.modelId || '—' }} /
                        {{ assignment.elevation?.elevationCode || assignment.elevationId || '—' }}
                      </span>
                    }
                  </div>
                } @else {
                  {{ row.modelId || '—' }}/{{ row.elevationId || '—' }}
                }
              </td>
              <td>
                @if (row.applyToAllModelsAndElevations) {
                  All
                } @else if (row.assignments?.length) {
                  {{ row.assignments.length }}
                } @else {
                  0
                }
              </td>
              <td>{{ row.product?.salesOffice ? 'Yes' : 'No' }}</td>
              <td>{{ row.product?.designCenter ? 'Yes' : 'No' }}</td>
              <td>{{ row.product?.sellable ? 'Yes' : 'No' }}</td>
              <td>{{ row.product?.isGlobal ? 'Yes' : 'No' }}</td>
              <td>{{ row.product?.selectionRequired ? 'Yes' : 'No' }}</td>
              <td>{{ row.product?.uofm?.code || '—' }}</td>
              <td class="text-end">{{ row.quantity ?? 0 }}</td>
              <td class="text-end">{{ (row.unitPrice | number: '1.2-2') ?? 0 }}</td>
              <td class="text-end">
                {{ (row.quantity ?? 0) * (row.unitPrice ?? 0) | currency: currencySymbol() ?? undefined : 'symbol' }}
              </td>
              <td class="text-center">
                <div class="dropdown">
                  <span data-bs-toggle="dropdown" style="cursor: pointer">
                    <svg-icon [name]="'menu-dots'" class="svg-24"></svg-icon>
                  </span>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <button class="dropdown-item" (click)="onEdit(row)">Edit</button>
                    <button class="dropdown-item" (click)="onSellingPrice(row.id!)">Selling Price</button>
                    <button class="dropdown-item text-danger" (click)="onRemove(row, $event)">Delete</button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="expandedrow" let-row>
            <tr>
              <td class="table-collapse-inner" colspan="13">
                <div class="mb-3 d-flex align-items-center">
                  <h3 class="mb-0">Linked Products</h3>
                </div>
                <div class="table-outer table-collapse h-auto">
                  <p-table [className]="'table-prime'" [value]="row.linkedProducts ?? []">
                    <ng-template #header>
                      <tr>
                        <th>Product Code</th>
                        <th>Description</th>
                        <th>Quantity</th>
                        <th>UofM</th>
                        <th>Category Description</th>
                        <th>Sub-category Description</th>
                        <th>Discontinued</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-linkedProduct>
                      <tr class="linked-product-row">
                        <td>{{ linkedProduct.product?.code || '—' }}</td>
                        <td>
                          {{ linkedProduct.product?.description || linkedProduct.product?.salesDescription || '—' }}
                        </td>
                        <td>{{ linkedProduct.quantity ?? '—' }}</td>
                        <td>{{ linkedProduct.product?.uofm?.code || '—' }}</td>
                        <td>{{ linkedProduct.product?.subcategory?.category?.description || '—' }}</td>
                        <td>{{ linkedProduct.product?.subcategory?.description || '—' }}</td>
                        <td>{{ !linkedProduct.product?.isActive ? 'Yes' : 'No' }}</td>
                        <td class="text-center">
                          <a class="ms-3 cursor-pointer" (click)="onEditLinkedProduct(row, linkedProduct)">
                            <i class="bi bi-pencil-square lh-1 me-2"></i>Edit
                          </a>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                      <tr>
                        <td colspan="8" class="text-center p-4 text-muted">
                          <i class="bi bi-info-circle me-2"></i>
                          No linked products found
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="13" class="text-center">No product items found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<!-- Edit Linked Product Quantity Modal -->
<ng-template #editLinkedProductModal let-modal>
  <form [formGroup]="quantityForm" (ngSubmit)="onSaveLinkedProductQuantity()">
    <div class="d-flex flex-column h-100">
      <div class="modal-header">
        <h1 class="modal-title">Edit Quantity</h1>
        <span (click)="onCancelEditLinkedProduct()" role="button">
          <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
        </span>
      </div>

      <div class="modal-body">
        @if (selectedLinkedProduct()) {
          <div class="mb-3">
            <label class="form-label">Product Code</label>
            <div class="form-control-plaintext">{{ selectedLinkedProduct()?.product?.code || '—' }}</div>
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <div class="form-control-plaintext">
              {{
                selectedLinkedProduct()?.product?.description ||
                  selectedLinkedProduct()?.product?.salesDescription ||
                  '—'
              }}
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Quantity <span class="text-danger">*</span></label>
            <input
              type="number"
              class="form-control"
              formControlName="quantity"
              placeholder="Enter quantity"
              min="0"
              [class.is-invalid]="quantityForm.get('quantity')?.invalid && quantityForm.get('quantity')?.touched"
            />
            @if (quantityForm.get('quantity')?.hasError('required') && quantityForm.get('quantity')?.touched) {
              <small class="text-danger">Quantity is required</small>
            } @else if (quantityForm.get('quantity')?.hasError('min') && quantityForm.get('quantity')?.touched) {
              <small class="text-danger">Quantity cannot be negative</small>
            }
          </div>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCancelEditLinkedProduct()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="quantityForm.invalid">Save</button>
      </div>
    </div>
  </form>
</ng-template>

<!-- Selling Price Modal -->
<ng-template #sellingPriceModal let-modal>
  <div class="modal-header">
    <h1 class="modal-title">Selling Price History</h1>
    <i
      class="bi bi-plus-circle fs-24 ms-2 mt-2 text-primary"
      role="button"
      [ngbTooltip]="'Add New Price'"
      placement="top"
      (click)="addNew.set(true); editingSellingPriceHistory.set(null); newFieldData.set(null)"
    ></i>
    <span role="button" (click)="modal.dismiss('Cross click')">
      <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
    </span>
  </div>

  <div class="modal-body">
    @if (addNew() || editingSellingPriceHistory()) {
      <div class="bg-light p-3 rounded-4 mb-3">
        <lib-selling-price-history-form
          [currencySymbol]="currencySymbol()"
          [modelElevationProductId]="selectedModelElevationId()!"
          [(editingSellingPriceHistory)]="editingSellingPriceHistory"
          [(addNew)]="addNew"
          (newFieldDetails)="newFieldDetails($event)"
          (reload)="sellingPriceHistory.reload(); linkedProductUpdated.emit()"
        />
      </div>
    }

    <div class="flex-fill overflow-hidden">
      <div class="table-outer table-theme">
        <div class="table-responsive h-100">
          <p-table [value]="sellingPriceHistory.value() ?? []">
            <ng-template #header>
              <tr>
                <th>Effective Date</th>
                <th class="text-center">Quantity</th>
                <th class="text-center">Unit Price</th>
                <th class="text-center">Amount</th>
                <th class="text-center">Retail Credit</th>
                <!-- <th class="text-center" width="50">Actions</th> -->
              </tr>
            </ng-template>
            <ng-template #body let-sellingPriceHistory of sellingPriceHistory.value()>
              <tr>
                <td>{{ sellingPriceHistory.effectiveDate | date }}</td>
                <td class="text-center">{{ sellingPriceHistory.quantity }}</td>
                <td class="text-center">{{ sellingPriceHistory.unitPrice | number: '1.2-2' }}</td>
                <td class="text-center">
                  {{ sellingPriceHistory.amount | currency: currencySymbol() ?? undefined : 'symbol' }}
                </td>
                <td class="text-center">{{ sellingPriceHistory.retailCredit | number: '1.0-2' }}</td>
                <!-- <td class="text-center">
                  <i
                    class="bi bi-pencil-square text-info"
                    (click)="editingSellingPriceHistory.set(sellingPriceHistory)"
                  ></i>
                </td> -->
              </tr>
              <!-- <tr>
                <td>01/01/2025</td>
                <td>11</td>
                <td class="text-end">$250.00</td>
                <td class="text-end">$250.00</td>
                <td class="text-end">00.00</td>
                <td class="text-center">
                  <i class="bi bi-pencil-square text-info"></i>
                </td>
              </tr> -->
            </ng-template>
            @if (addNew()) {
              <ng-template #footer>
                <tr>
                  <td>{{ newFieldData()?.effectiveDate | date: 'dd/MM/yyyy' }}</td>
                  <td class="text-center">{{ newFieldData()?.quantity }}</td>
                  <td class="text-center">{{ newFieldData()?.unitPrice | number: '1.2-2' }}</td>
                  <td class="text-center">
                    @if (newFieldData()?.unitPrice && newFieldData()?.quantity) {
                      {{ newFieldData()!.unitPrice * newFieldData()!.quantity | number: '1.0-2' }}
                    }
                  </td>
                  <td class="text-center">{{ newFieldData()?.retailCredit | number: '1.0-2' }}</td>
                  <!-- <td class="text-center">
                    <i class="bi bi-pencil-square text-info"></i>
                  </td> -->
                </tr>
              </ng-template>
            }
          </p-table>
        </div>
      </div>
    </div>
  </div>
</ng-template>
